import { z } from 'zod/v4';

export const CompanyToSwitchRowSchema = z.object({
  id: z.string(),
  companyId: z.string(),
  userId: z.string(),
  isPrimary: z.boolean(),
  hasAgreedWithTerms: z.boolean(),
  hasAgreedWithTermsAt: z.string().nullable(),
  name: z.string(),
  officialName: z.string(),
  isDemoCompany: z.number(),
  isClientCompany: z.number(),
});

export type CompanyToSwitchRow = z.infer<typeof CompanyToSwitchRowSchema>;

// Bare array — no `{data, meta}` envelope. Matches the legacy
// `reply.code(200).send(result)` shape both frontend consumers expect.
export const CompaniesToSwitchResponseSchema = z.array(
  CompanyToSwitchRowSchema,
);

export type CompaniesToSwitchResponse = z.infer<
  typeof CompaniesToSwitchResponseSchema
>;
